import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import { useWishlist } from "@/hooks/useWishlist";
import { cn } from "@/lib/utils";

interface WishlistButtonProps {
  productId: string;
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "default" | "lg" | "icon";
  className?: string;
}

const WishlistButton = ({ 
  productId, 
  variant = "outline", 
  size = "sm",
  className 
}: WishlistButtonProps) => {
  const { 
    isInWishlist, 
    addToWishlist, 
    removeFromWishlist, 
    isAddingToWishlist, 
    isRemovingFromWishlist 
  } = useWishlist();

  const inWishlist = isInWishlist(productId);
  const isLoading = isAddingToWishlist || isRemovingFromWishlist;

  const handleClick = () => {
    if (inWishlist) {
      removeFromWishlist(productId);
    } else {
      addToWishlist(productId);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      disabled={isLoading}
      className={cn(className)}
    >
      <Heart 
        className={cn(
          "h-4 w-4",
          inWishlist && "fill-current text-red-500"
        )} 
      />
      {size !== "sm" && size !== "icon" && (
        <span className="ml-2">
          {inWishlist ? "Remove from Wishlist" : "Add to Wishlist"}
        </span>
      )}
    </Button>
  );
};

export default WishlistButton;
